import { motion } from "framer-motion";
import { useIsMobile, reveal } from "@/lib/motion";
import { GLOW, glassReveal } from "@/lib/glass";

// Closing marks, one gold family, three signatures:
//   numeral — a hairline drawn across the measure, sealed by the final numeral
//   lozenge — two hairlines meeting at a small turned square
//   bold    — a heavier lit line, the weight of a verdict
export default function Seal({ variant = "lozenge", numeral, testId, style }) {
  const mobile = useIsMobile();
  const fade = {
    initial: { opacity: 0 },
    whileInView: { opacity: 1 },
    ...glassReveal(reveal(mobile, { duration: 1.1 })),
  };
  const draw = (origin) => ({
    initial: { scaleX: 0 },
    whileInView: { scaleX: 1 },
    ...glassReveal(reveal(mobile, { duration: 1.5, delay: 0.1 })),
    className: `seal-line block h-px flex-1 ${origin}`,
  });

  if (variant === "numeral") {
    return (
      <motion.div {...fade} data-testid={testId} style={style} aria-hidden="true" className="flex items-center gap-5">
        <motion.span {...draw("origin-left")} />
        <span
          className="font-display text-[22px] font-light leading-none text-[#84DFF4]/60 md:text-[26px]"
          style={{ textShadow: GLOW.gold }}
        >
          {numeral}
        </span>
      </motion.div>
    );
  }

  if (variant === "bold") {
    return (
      <motion.div {...fade} data-testid={testId} style={style} aria-hidden="true" className="mx-auto w-[82%] max-w-[640px]">
        <motion.span
          initial={{ scaleX: 0.3 }}
          whileInView={{ scaleX: 1 }}
          {...glassReveal(reveal(mobile, { duration: 1.4 }))}
          className="seal-line-bold block h-[2px] origin-center"
        />
      </motion.div>
    );
  }

  return (
    <motion.div {...fade} data-testid={testId} style={style} aria-hidden="true" className="mx-auto flex max-w-[420px] items-center gap-5">
      <motion.span {...draw("origin-right")} />
      <span className="seal-lozenge block h-2.5 w-2.5 rotate-45 border border-[#8E8E93]/70" />
      <motion.span {...draw("origin-left")} />
    </motion.div>
  );
}
